/**
 * Created by Karan variya on 24/12/2018.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { UserComponent } from './user.page';
import { UserDetailComponent } from '../userdetail/userdetail.page';
export const routes: Routes = [
    { path: 'user', component: UserComponent },
    { path: 'user/:id1/:id2', component: UserDetailComponent }
];
@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        RouterModule.forChild(routes)
    ],
    declarations: [
        UserComponent,
        UserDetailComponent
    ]
})
export class UserModule { }


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/app/structure/user/user.module.ts